import axios from "axios";

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/favoritos/`;

export default class favoritos {
  static async getProductoFavoritos(clienteId, contactoId) {
    const respuesta = await axios
      .get(`${ENDPOINT}getProductoFavoritos/${clienteId}/${contactoId}`)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async esFavorito(clienteId, contactoId, productoId) {
    const respuesta = await axios
      .get(`${ENDPOINT}esFavorito/${clienteId}/${contactoId}/${productoId}`)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async agregarProductoFavorito(request) {
    const respuesta = await axios
      .post(`${ENDPOINT}agregarProductoFavorito`, request)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }

  static async eliminarProductoFavorito(request) {
    const respuesta = await axios
      .post(`${ENDPOINT}eliminarProductoFavorito`, request)
      .then((response) => {
        return response;
      });
    return respuesta.data;
  }
}
